import React from 'react';

import NylasGrant from 'components/nylas/v3/grant';
import * as scopes from 'components/nylas/v3/scopes';

import type { Props as NylasGrantProps } from 'components/nylas/v3/grant';

interface Props {
  nylas: NylasGrantProps;
}

export default function CrmIntegrationSettings({ nylas }: Props) {
  return <>
    <h3>CRM Integrations</h3>
    <h4>Private contact emails</h4>
    <NylasGrant {...nylas} scopes={scopes.messageNotifications} />
  </>;
}
